import PopupIcon from "./PopupIcon";
import PopupImage from "./PopupImage";

const AuctionDetails = () => {
  return (
    <div>
      <PopupIcon title="2017 BMW M3 Competition Auto For Sale R819,900" />
      <div>
        <PopupImage />
      </div>
    </div>
  );
};

export default AuctionDetails;
